import { render, staticRenderFns } from "./opened.vue?vue&type=template&id=4f051e4e&scoped=true"
import script from "./opened.vue?vue&type=script&lang=js"
export * from "./opened.vue?vue&type=script&lang=js"
import style0 from "./opened.vue?vue&type=style&index=0&id=4f051e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f051e4e",
  null
  
)

export default component.exports